import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { IconTypes } from './icon-types';

@Component({
  selector: 'mtg-svg-icon',
  templateUrl: './svg-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
  @Input()
  icon: IconTypes;
  @HostBinding('class.svg-icon')
  defaultClass = true;

  get iconHref(): string {
    return `#${this.icon}`;
  }
}
